/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentStatusResponse
 */
export interface PaymentStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentStatusResponse
     */
    paymentReference: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentStatusResponse
     */
    isPaymentResultAvailable: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentStatusResponse
     */
    returnUrl?: string;
}

/**
 * Check if a given object implements the PaymentStatusResponse interface.
 */
export function instanceOfPaymentStatusResponse(value: object): value is PaymentStatusResponse {
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('isPaymentResultAvailable' in value) || value['isPaymentResultAvailable'] === undefined) return false;
    return true;
}

export function PaymentStatusResponseFromJSON(json: any): PaymentStatusResponse {
    return PaymentStatusResponseFromJSONTyped(json, false);
}

export function PaymentStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentReference': json['paymentReference'],
        'isPaymentResultAvailable': json['isPaymentResultAvailable'],
        'returnUrl': json['returnUrl'] == null ? undefined : json['returnUrl'],
    };
}

export function PaymentStatusResponseToJSON(json: any): PaymentStatusResponse {
    return PaymentStatusResponseToJSONTyped(json, false);
}

export function PaymentStatusResponseToJSONTyped(value?: PaymentStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentReference': value['paymentReference'],
        'isPaymentResultAvailable': value['isPaymentResultAvailable'],
        'returnUrl': value['returnUrl'],
    };
}

